export default "__VITE_ASSET__6W7AKyJX__"